import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('pkpPhaseLabel', pkpPhaseLabel);

    /**
     * Displaying the phase label based on the phase (i.e. LIVE).
     *
     * @author flzemke.btc
     * @ngInject
     */
    function pkpPhaseLabel(DATES) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                phase: '=',
                auction: '=',
                suspended: '=',
                auctionStart: '=',
                isAuction: '=?'
            },
            template: require('app/_directives/pkp-phase-label.directive.html'),
            link: linkFn
        };

        function linkFn(scope) {
            scope.DATES = DATES;
        }
    }
})();
